var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Your mission")]),_c('p',[_vm._v("Your mission as Backend Developer is to build an API that "),_c('router-link',{attrs:{"to":"/frontend"}},[_vm._v("Frontend GUI")]),_vm._v(" can consume.")],1),_c('ApiOverview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }